import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ApplicationState } from "../store";
import { APIState } from "../store/API/types";
import { setSourceForBookmarkPane } from "../store/bookmarks/actions";
import { BookmarkState } from "../store/bookmarks/types";
import { getLocalBounds, chooseService } from "../utils";

const {CONFIG} = window;


const useGetBookmarkFrame = (pane: number, ref: React.RefObject<HTMLImageElement>) => {
  const {token, token2} = useSelector<ApplicationState, APIState>(state => state.API);
  const {bookmarks} = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);
  const dispatch = useDispatch();

  const bkm = bookmarks[pane]
    ? bookmarks[pane]
    : null;

  const fetch = bkm && bkm.fetch;

  useEffect(() => {
    if (bkm && fetch) {
      const {width} = getLocalBounds(document.getElementById(`thumbnail-${pane}`));
      const src = chooseService(
        () => `https://${CONFIG.ServerAddress}:${CONFIG.ServerPort}/session/get_thumbnail?token=${token}${token2 ? `&token2=${token2}` : ''}&id=${bkm.id}&time=${bkm.timeBounds.start}`,
        () => `https://${CONFIG.ServerAddress}:${CONFIG.ServerPort}/SeeTecGatewayService/GatewayServiceRest/Request_Bare_Archive_JPEG?sessionID=${token}&cameraEntityID=${bkm.id}&imageWidth=${width}&timestamp=${bkm.timeBounds.start}`
      );
      dispatch(setSourceForBookmarkPane(src, pane));
    }
  }, [fetch]);
};

export default useGetBookmarkFrame